import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropAuthor } from "./SingleWaveDropAuthor";
interface SingleWaveDropInfoAuthorSectionProps {
  readonly drop: ExtendedDrop | undefined;
}
export const SingleWaveDropInfoAuthorSection: React.FC<SingleWaveDropInfoAuthorSectionProps> = t0 => {
  const $ = _c(2);
  const {
    drop
  } = t0;
  if (!drop) {
    return null;
  }
  let t1;
  if ($[0] !== drop) {
    t1 = <SingleWaveDropAuthor drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};